import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignCareReceiverMemberToCaregiverMembersMutationVariables = Types.Exact<{
  data: Types.AssignCareReceiverMemberToCaregiverMembersInput;
}>;


export type AssignCareReceiverMemberToCaregiverMembersMutation = { __typename?: 'Mutation', assignCareReceiverMemberToCaregiverMembers: { __typename?: 'OrganisationMemberUser', id: string, user: { __typename?: 'User', id: string, username: string, superPals: Array<{ __typename?: 'User', id: string }> } } };


export const AssignCareReceiverMemberToCaregiverMembersDocument = gql`
    mutation AssignCareReceiverMemberToCaregiverMembers($data: AssignCareReceiverMemberToCaregiverMembersInput!) {
  assignCareReceiverMemberToCaregiverMembers(data: $data) {
    id
    user {
      id
      username
      superPals {
        id
      }
    }
  }
}
    `;
export type AssignCareReceiverMemberToCaregiverMembersMutationFn = Apollo.MutationFunction<AssignCareReceiverMemberToCaregiverMembersMutation, AssignCareReceiverMemberToCaregiverMembersMutationVariables>;

/**
 * __useAssignCareReceiverMemberToCaregiverMembersMutation__
 *
 * To run a mutation, you first call `useAssignCareReceiverMemberToCaregiverMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCareReceiverMemberToCaregiverMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCareReceiverMemberToCaregiverMembersMutation, { data, loading, error }] = useAssignCareReceiverMemberToCaregiverMembersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignCareReceiverMemberToCaregiverMembersMutation(baseOptions?: Apollo.MutationHookOptions<AssignCareReceiverMemberToCaregiverMembersMutation, AssignCareReceiverMemberToCaregiverMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCareReceiverMemberToCaregiverMembersMutation, AssignCareReceiverMemberToCaregiverMembersMutationVariables>(AssignCareReceiverMemberToCaregiverMembersDocument, options);
      }
export type AssignCareReceiverMemberToCaregiverMembersMutationHookResult = ReturnType<typeof useAssignCareReceiverMemberToCaregiverMembersMutation>;
export type AssignCareReceiverMemberToCaregiverMembersMutationResult = Apollo.MutationResult<AssignCareReceiverMemberToCaregiverMembersMutation>;
export type AssignCareReceiverMemberToCaregiverMembersMutationOptions = Apollo.BaseMutationOptions<AssignCareReceiverMemberToCaregiverMembersMutation, AssignCareReceiverMemberToCaregiverMembersMutationVariables>;